/**
 * DOM 을 FadeOut 시키는 함수
 * @param dom fadeOut 시킬 대상의 Element
 * @param time fadeOut 하는 시간 (단위 ms, 기본값 200ms)
 * @param callback
 */
export const fadeOut = (dom: HTMLElement, time = 200, callback?: () => void): void => {
  dom.style.transition = `opacity ${time}ms linear`
  dom.style.opacity = '0'
  if (callback) {
    setTimeout(callback, time + 100)
  }
}
